import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('would_you_like_to_logout'),
    text: defineMessage('we_couldnt_find_those_i_iated_with_this_account'),
    logout: defineMessage('logout'),
    stayLoggedIn: defineMessage('stay_logged_in'),
};
